import { Switch, Redirect, Route, useHistory, useRouteMatch } from 'react-router-dom';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import React, { useContext, useEffect, useState } from 'react';

import senslaLogo from 'assets/images/sensla-logo.png';
import Logs from 'components/Logs';
import Pillars from 'components/Pillars';
import PillarsReport from 'components/PillarsReport';
import RealTime from 'components/RealTime';
import Reports from 'components/Reports';
import SurveysReport from 'components/SurveysReport';
import UserDetails from 'components/UserDetails';
import RTWorkspace from 'components/RTWorkspace';
import Settings from 'components/Settings';
import Sidebar from 'components/Sidebar';
import Summary from 'components/Summary';

import { ctx, IStore } from 'store';

import { useStyles } from './styles';

const DashboardHome: React.FC = () => {
  const history = useHistory();
  const match = useRouteMatch();
  const [collapsed, setCollapsed] = useState(true);
  const [toggled, setToggled] = useState(false);
  const {
    teams: { currentTeam },
    data: { data },
    auth: { user },
  } = useContext(ctx.store);
  const actions = useContext(ctx.actions);

  const classes = useStyles();

  useEffect(() => {
    if (!currentTeam) {
      const savedTeam = localStorage.getItem('team');
      if (!savedTeam) {
        history.push('/home');
      } else {
        const parsedTeam = JSON.parse(savedTeam);
        const sup = parsedTeam.supervisors.map((item: any) => item.email).includes(user.email);
        if (parsedTeam.preset) {
          if (sup) {
            setTeam(parsedTeam);
          } else {
            history.push('/home');
          }
        } else {
          history.push('/preset');
        }
      }
    } else {
      if (!currentTeam.preset) {
        history.push('/preset');
      } else if (!currentTeam.supervisors.map((item: any) => item.email).includes(user.email)) {
        history.push('/home');
      }
    }
  }, []);

  useEffect(() => {
    if (data.length) {
      if (currentTeam) {
        document.title = `(${data.length}) Sensla | ${currentTeam.name}`;
      } else {
        document.title = `(${data.length}) Sensla | Analysis for a Great Environment`;
      }
    } else {
      if (currentTeam) {
        document.title = `Sensla | ${currentTeam.name}`;
      } else {
        document.title = 'Sensla | Analysis for a Great Environment';
      }
    }
  }, [data]);

  const setTeam = async (team: any) => {
    if (team.teamId) {
      await ((actions.teams.getTeam(team.teamId) as unknown) as Promise<IStore>);
    } else {
      await ((actions.tenants.getTenant(team.tenantId) as unknown) as Promise<IStore>);
    }
  };

  const handleCollapsedChange = (checked: boolean) => {
    setCollapsed(checked);
  };

  const handleToggleSidebar = (value: boolean) => {
    setToggled(value);
  };

  if (!currentTeam) {
    return <div />;
  }

  return (
    <RealTime>
      <div className={classes.root}>
        <Sidebar
          collapsed={collapsed}
          rtl={false}
          toggled={toggled}
          handleToggleSidebar={handleToggleSidebar}
          handleCollapsedChange={handleCollapsedChange}
        />
        <Hidden smUp>
          <Grid xs={12} md={6} className={classes.headerMobile}>
            <IconButton
              aria-label="delete"
              className={classes.toggleButton}
              size="small"
              onClick={() => handleToggleSidebar(true)}
            >
              <MenuIcon className={classes.toggleIcon} />
            </IconButton>
            <img alt="sensla logo" src={senslaLogo} className={classes.senslaLogo} />
          </Grid>
        </Hidden>
        <Container className={classes.container}>
          <Switch>
            <Route exact path={`${match.path}/realtime`}>
              <RTWorkspace />
            </Route>
            {/* <Route exact path={`${match.path}/channel`}>
              <RTChannel />
            </Route>
            <Route exact path={`${match.path}/member`}>
              <RTMember />
            </Route> */}
            <Route exact path={`${match.path}/reports`}>
              <Reports />
            </Route>
            <Route exact path={`${match.path}/member`}>
              <UserDetails />
            </Route>
            <Route exact path={`${match.path}/summary`}>
              <Summary />
            </Route>
            <Route exact path={`${match.path}/settings`}>
              <Settings />
            </Route>
            <Route exact path={`${match.path}/logs`}>
              <Logs />
            </Route>
            <Route exact path={`${match.path}/pillars`}>
              <Pillars />
            </Route>
            <Route exact path={`${match.path}/pillars-report`}>
              <PillarsReport />
            </Route>
            <Route exact path={`${match.path}/surveys-report`}>
              <SurveysReport />
            </Route>
            <Route path={match.path}>
              <Redirect to={`${match.path}/pillars`} />
            </Route>
          </Switch>
        </Container>
      </div>
    </RealTime>
  );
};

export { DashboardHome };
